<div class="p-4 h-100 position-relative" [appStoryblok]="_editable">
  <img fill *ngIf="image?.filename" [ngSrc]="image.filename || ''" />
  <div class="z-1 position-relative d-flex flex-column h-100">
    <h2 class="h5 fw-600" *ngIf="name">{{ name }}</h2>
    <a class="mt-auto ms-auto" *ngIf="link?.id" [storyblokLink]="link">
      <img width="36" height="36" src="/assets/right-circle.svg" />
    </a>
  </div>
</div>
